<template>
  <div>
    <div
      class="flex flex-wrap justify-center items-center w-full mb-4"
    >
      <div
        v-for="(account, index) in availableAccounts"
        :key="index"
        :ref="'availableAccount_' + index"
        class="mt-4 xl:mt-0 relative"
        @click="display(index)"
      >
        <div
          class="text-center"
          :style="[!cardOpened ? {'margin-right': '25%'} : {'margin-right': '50%'}]"
        >
          <img
            class="absolute w-12 xl:mt-px"
            src="/images/landingpage/ribbon.png"
            alt="ribbon"
          >
        </div>
        <div
          v-if="cardOpened"
          class="text-center ribbon-image"
        >
          <img
            class="absolute w-12 xl:mt-px"
            src="/images/landingpage/ribbon.png"
            alt="ribbon"
          >
        </div>
        <div
          class="cursor-pointer flex justify-center flex-wrap opacity-hover landing-transition landing-card"
          :style="[cardOpened ? '' : index === 0
            ? {'background': 'rgba(255, 255, 255, 0.1) url(/images/landingpage/BE.png) no-repeat left 100px top 180px'}
            : index === 1 ? {'background': 'rgba(255, 255, 255, 0.1) url(/images/landingpage/ChampionAccounts.png) no-repeat left 140px top 180px'}
              : index === 2 ? {'background': 'rgba(255, 255, 255, 0.1) url(/images/landingpage/mask.png) no-repeat left 85px top 180px'}
                : index === 3 ? {'background': 'rgba(255, 255, 255, 0.1) url(/images/landingpage/HighAccounts.png) no-repeat left 2px top 90px'} : '']"
        >
          <div class="flex flex-col">
            <div :class="['card-container', `${ cardOpened ? 'ml-6 md:ml-0' : ''}`]">
              <div :class="['uppercase flex font-bold py-2 text-smurfs-gold subtitle landing-account-name', `${ cardOpened ? 'ml-6 md:ml-0' : ''}`]">
                {{ account.name }}
                <div>
                  <img
                    v-if="index === 0 && !cardOpened"
                    class="landing-card-best-value"
                    :src="'/images/landingpage/best.png'"
                    alt=""
                  >
                </div>
              </div>

              <div class="simple-text-container">
                <ul
                  class="list-disc pl-4 pl-18px"
                >
                  <li
                    v-for="(listElement, list_index) in account.list_elements"
                    :key="list_index"
                  >
                    {{ listElement }}
                  </li>
                </ul>
              </div>
            </div>

            <div
              v-if="!cardOpened"
              class="text-smurfs-gold"
            >
              See More  <i class="fas fa-arrow-circle-right" />
            </div>

            <div class="flex flex-1" />
            <div
              :ref="'closeButton_' + index"
              class="flex justify-center items-center landing-transition landing-hide mb-10 lg:mb-0 close-button"
              @click="showAllCards(index);"
            >
              <i
                class="fa fa-times fa-times-color"
                aria-hidden="true"
              />
            </div>
          </div>

          <div
            v-if="account.offers"
            class="flex flex-col offered-accounts-width"
          >
            <div
              v-if="account.category_exists"
              class="flex flex-wrap justify-center items-center"
            >
              <a
                v-for="(offer , offerIndex) in account.offers"
                :key="offerIndex"
                :href="offer ? offer.url : null"
              >
                <div
                  v-if="offer"
                  :ref="'information_' + offerIndex + '_' + index"
                  class="m-2 landing-transition landing-hide landing-card"
                  :style="'width: 224px; height: 320px; border-radius: 50px; padding: 35px; background: ' + offer.background"
                >
                  <div class="text-sm text-smurfs-gold">
                    {{ offer.from_above }}
                  </div>

                  <div class="uppercase flex font-bold py-1 text-smurfs-gold subtitle">
                    {{ offer.title }}
                  </div>

                  <div class="simple-text-container flex font-bold py-1 mb-0 subtitle ">
                    <del>{{ offer.price.last }}</del>
                  </div>

                  <div class="uppercase flex font-bold py-1 text-smurfs-gold subtitle fs-x-large">
                    {{ offer.price.present }}
                  </div>
                  <div class="simple-text-container flex font-bold py-1 subtitle">
                    SERVER: {{ offer.region }}
                  </div>
                  <div
                    v-if="cardOpened"
                    class="text-smurfs-gold"
                    :style="[index === 2 ? {'margin-top': '-8%'} : {'margin-top': '20%'}]"
                  >
                    See More  <i class="fas fa-arrow-circle-right" />
                  </div>
                </div>
                <div
                  v-else
                  :ref="'information_' + offerIndex + '_' + index"
                  class="m-2 landing-transition landing-hide landing-card out-of-stock-card"
                >
                  <div class="text-center">
                    <i class="fa fa-times-circle out-of-stock-cross" />
                  </div>

                  <div class="text-center text-smurfs-gold mt-2">
                    Out of stock!
                  </div>

                  <div class="text-center out-of-stock-text bold mt-4">
                    We are sorry, but we currently don't have more variants in this category. Check later or inquire over email or live chat about the availability
                  </div>
                </div>
              </a>
            </div>

            <div
              v-if="!account.category_exists && cardOpened"
              class="m-2 out-of-stock-rectangle"
            >
              <div class="text-center">
                <i class="fa fa-times-circle out-of-stock-cross-red" />
              </div>

              <div class="text-center out-of-stock-heading bold text-smurfs-gold mt-2">
                These Items are Out of stock!
              </div>

              <div class="text-center out-of-stock-main-text bold mt-4">
                Sorry, but we don't have any products in this category on the chosen server. Let us know if you are interested, and we can add it in the future
              </div>
            </div>

            <div
              :ref="'button_' + index"
              class="flex mt-6 landing-transition landing-hide account-all-urls"
            >
              <a
                :href="account.view_all_url"
                class="btn btn-white text-md mt-2landing-button mt-auto landing-btn-style flex justify-center items-center"
              >
                <div class="view-all-width">
                  <span class="uppercase">VIEW ALL</span>
                  <span class="noBorderedButton">
                    <i
                      class="fa fa-arrow-right"
                      aria-hidden="true"
                    />
                  </span>
                </div>
              </a>
            </div>
          </div>

          <div
            v-else-if="account.information"
            class="flex flex-col account-information-width"
          >
            <div
              :ref="'description_' + index"
              class="simple-text-container text-center landing-transition landing-hide account-information-description"
            >
              {{ account.information.description }}
            </div>
            <div class="flex flex-wrap  justify-center items-center">
              <a
                v-for="(card, card_index) in account.information.cards"
                :key="card_index"
                :href="card.url"
              >
                <div
                  :ref="'card_' + card_index + '_' + index"
                  class="m-2 landing-transition landing-hide justify-center items-center text-center landing-card card-border-radius"
                >
                  <div class="uppercase font-bold py-1 subtitle card-name-margin">
                    {{ card.name }}
                  </div>
                  <div
                    v-if="cardOpened"
                    class="text-smurfs-gold mt-4"
                  >
                    See More  <i class="fas fa-arrow-circle-right" />
                  </div>
                </div>
              </a>
            </div>
            <div
              :ref="'button_' + index"
              class="flex mt-6 landing-transition landing-hide account-all-urls"
            >
              <a
                :href="account.view_all_url"
                class="btn btn-white text-md mt-2landing-button mt-auto landing-btn-style flex justify-center items-center"
              >
                <div class="view-all-width">
                  <span class="uppercase">VIEW ALL</span>
                  <span class="noBorderedButton">
                    <i
                      class="fa fa-arrow-right"
                      aria-hidden="true"
                    />
                  </span>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="!cardOpened"
      class="text-center text-sm mb-10 mt-10"
    >
      Do you need an account on a different region?
      <select
        v-model="currentRegion.value"
        class="ml-2 p-2 mt-2 xl:mt-0 rounded-lg bg-transparent border text-honestly-white"
        @change="setCodeAndLabelForForm(currentRegion.value)"
      >
        <option
          :value="null"
          disabled
          selected
        >
          Select your region
        </option>
        <option
          v-for="(region, index) in regions"
          :key="index"
          :value="region.short"
        >
          {{ region.value }}
        </option>
      </select>
    </div>
  </div>
</template>

<script>
import axios from "axios";

const CARDS_COUNT = 4;

export default {
  props: {
    regions: {
      type: Array,
      default: null,
    },
    packages: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      currentRegion: {
        value: null
      },
      availableAccounts: this.setAvailableAccounts(this.packages),
      empty: true,
      displayMayWork: true,
      cardOpened: false,
    };
  },

  methods: {
    display(index) {
      if (!this.displayMayWork) {
        this.displayMayWork = true;
        return;
      } else if (this.cardOpened) {
        return;
      }

      for (let i = 0; i < CARDS_COUNT; ++i) {
        if (i !== index) {
          this.hideCard(i);
        }
      }
      this.showCard(index);
    },

    setAvailableAccounts(packageDetails){
      return [
        //be smurfs
        {
          name: 'be smurfs',
          list_elements: [
            'No ranking',
            'Fresh MMR',
            'A lot of Blue Essence',
          ],
          view_all_url: 'https://www.unrankedsmurfs.com/league-of-legends/lol-account?min_champions=0,0',
          category_exists: !!(packageDetails.minBeAccount && packageDetails.maxBeAccount),
          offers: [
            packageDetails.minBeAccount ?
              {
                url: packageDetails.minBeAccount.url,
                background: 'rgba(255,255,255,0.1)',
                from_above: 'From',
                region: packageDetails.minBeAccount.region_display_name,
                title: packageDetails.minBeAccount.min_blue_essence + ' + BE',
                price: {
                  last: 'USD ' + packageDetails.minBeAccount.old_price.toFixed(2),
                  present: 'USD ' + packageDetails.minBeAccount.price.toFixed(2),
                },
                facilities: [
                  'Fresh MMR',
                  packageDetails.minBeAccount.min_blue_essence + ' + BE',
                  'Lifetime Warranty ' + packageDetails.minBeAccount.verified ? '' : '& Unverified Email',
                ],
                background_image: '',
              }
              : null,
            packageDetails.maxBeAccount ?
              {
                url: packageDetails.maxBeAccount.url,
                background: 'rgba(247,183,51,0.1)',
                from_above: 'Up to',
                region: packageDetails.maxBeAccount.region_display_name,
                title: packageDetails.maxBeAccount.min_blue_essence + ' + BE',
                price: {
                  last: 'USD ' + packageDetails.maxBeAccount.old_price.toFixed(2),
                  present: 'USD ' + packageDetails.maxBeAccount.price.toFixed(2),
                },
                facilities: [
                  'Fresh MMR',
                  packageDetails.maxBeAccount.min_blue_essence + ' + BE',
                  'Lifetime Warranty ' + packageDetails.maxBeAccount.verified ? '' : '& Unverified Email',
                ],
                background_image: '',
              }
              : null,
          ],
        },

        //Champion accounts
        {
          name: 'Champion accounts',
          list_elements: [
            'Matured and extremely safe',
            'Random Champions',
            'Best for high elo climb',
          ],
          view_all_url: 'https://www.unrankedsmurfs.com/league-of-legends/lol-account?min_champions=1',
          category_exists: !!(packageDetails.minChampionAccount && packageDetails.maxChampionAccount),
          offers: [
            packageDetails.minChampionAccount ?
              {
                url: packageDetails.minChampionAccount.url,
                background: 'rgba(255,255,255,0.1)',
                from_above: 'From',
                region: packageDetails.minChampionAccount.region_display_name,
                title: packageDetails.minChampionAccount.min_champions + '+ Champions',
                price: {
                  last: 'USD ' + packageDetails.minChampionAccount.old_price.toFixed(2),
                  present: 'USD ' + packageDetails.minChampionAccount.price.toFixed(2),
                },
                facilities: [
                  'Hand Leveled',
                  'Random amount of BE',
                  'Lifetime Warranty ' + packageDetails.minChampionAccount.verified ? '' : '& Unverified Email',
                ],
                background_image: '',
              }
              : null,
            packageDetails.maxChampionAccount ?
              {
                url: packageDetails.maxChampionAccount.url,
                background: 'rgba(247,183,51,0.1)',
                from_above: 'Up to',
                region: packageDetails.minChampionAccount.region_display_name,
                title: packageDetails.maxChampionAccount.min_champions + '+ Champions',
                price: {
                  last: 'USD ' + packageDetails.maxChampionAccount.old_price.toFixed(2),
                  present: 'USD ' + packageDetails.maxChampionAccount.price.toFixed(2),
                },
                facilities: [
                  'Hand Leveled',
                  'Random amount of BE',
                  'Lifetime Warranty ' + packageDetails.minChampionAccount.verified ? '' : '& Unverified Email',
                ],
                background_image: '',
              }
              : null,
          ],
        },

        //Ranked Accounts
        {
          name: 'Ranked Accounts',
          list_elements: [
            'Guaranteed rank',
            packageDetails.minRankedAccount ? packageDetails.minRankedAccount.min_champions + '+ Champions' : '0 Champions',
            'Secured end of season rewards',
          ],
          view_all_url: 'https://www.unrankedsmurfs.com/league-of-legends/ranked-accounts',
          category_exists: !!(packageDetails.minRankedAccount && packageDetails.maxRankedAccount),
          offers: [
            packageDetails.minRankedAccount ?
              {
                url: packageDetails.minRankedAccount.url,
                background: 'rgba(255,255,255,0.1)',
                from_above: 'From',
                region: packageDetails.minRankedAccount.region_display_name,
                title: packageDetails.minRankedAccount.title,
                price: {
                  last: 'USD ' + packageDetails.minRankedAccount.old_price.toFixed(2),
                  present: 'USD ' + packageDetails.minRankedAccount.price.toFixed(2),
                },
                facilities: [
                  packageDetails.minRankedAccount.min_champions + '+ Champions',
                  packageDetails.minRankedAccount.min_champions > 0 ? 'Hand Leveled' : 'Fresh MMR',
                  packageDetails.minRankedAccount.min_blue_essence + '+ BE',
                  'Lifetime Warranty ' + packageDetails.minRankedAccount.verified ? '' : '& Unverified Email',
                ],
                background_image: '',
              }
              : null,
            packageDetails.maxRankedAccount ?
              {
                url: packageDetails.maxRankedAccount.url,
                background: 'rgba(247,183,51,0.1)',
                from_above: 'Up to',
                region: packageDetails.maxRankedAccount.region_display_name,
                title: packageDetails.maxRankedAccount.title,
                price: {
                  last: 'USD ' + packageDetails.maxRankedAccount.old_price.toFixed(2),
                  present: 'USD ' + packageDetails.maxRankedAccount.price.toFixed(2),
                },
                facilities: [
                  packageDetails.maxRankedAccount.min_champions + '+ Champions',
                  packageDetails.maxRankedAccount.min_champions > 0 ? 'Hand Leveled' : 'Fresh MMR',
                  'Random amount of BE',
                  'Lifetime Warranty ' + packageDetails.maxRankedAccount.verified ? '' : '& Unverified Email',
                ],
                background_image: '',
              }
              : null,
          ],
        },

        //high end accounts
        {
          name: 'high end accounts',
          list_elements: [
            'Filter by skins and Champions',
            'See Details of the account',
            'Rare skins available',
          ],
          view_all_url: 'https://www.unrankedsmurfs.com/league-of-legends/buy-skins',
          offers: false,
          information: {
            description:
              'In our High-Ends store you can find a variety of accounts ranging from few to few hundred skins. You can filter by champion and skins. In this section we feature rare skins and unique accounts.',
            cards: [
              {
                name: 'Pax Sivir',
                url:
                  'https://www.unrankedsmurfs.com/league-of-legends/buy-skins?skins=PAX+Sivir',
              },
              {
                name: 'Ufo Corki',
                url:
                  'https://www.unrankedsmurfs.com/league-of-legends/buy-skins?skins=UFO Corki',
              },
              {
                name: 'Judgement  Kayle',
                url:
                  'https://www.unrankedsmurfs.com/league-of-legends/buy-skins?skins=Judgement+Kayle',
              },
            ],
          },
        },
      ];
    },

    async setCodeAndLabelForForm(regionName){
      await axios.get('/api/landing-page/' + regionName)
        .then((response) => {
          this.availableAccounts = this.setAvailableAccounts(response.data.packageDetails);
        });
    },

    showAllCards(index) {
      for (let i = 0; i < CARDS_COUNT; ++i) {
        this.openCard(i);
      }

      this.hide(index);
      this.cardOpened = false;
    },

    hide(index) {
      let needToClose = [
        'closeButton_',
        'information_0_',
        'information_1_',
        'button_',
        'card_0_',
        'card_1_',
        'card_2_',
        'description_',
      ];

      needToClose.forEach(key => {
        let elementsToClose = this.$refs[key + index];
        if (elementsToClose && elementsToClose.length !==0) {
          // there is only one element which should be closed
          elementsToClose[0].classList.add('landing-hide');
        }
      });

      this.displayMayWork = false;
    },

    hideCard(index) {
      let card = this.$refs['availableAccount_' + index][0];
      card.style.width = card.offsetWidth + 'px';
      card.style.height = card.offsetHeight + 'px';
      card.classList.add('landing-hide');
      card.setAttribute('style', '');
    },

    openCard(index) {
      let card = this.$refs['availableAccount_' + index][0];
      card.style.width = '250px';
      card.style.height = '314px';
      card.classList.remove('landing-hide');
    },

    showCard(index) {
      let card = this.$refs['availableAccount_' + index][0];
      card.setAttribute('style', '');

      let needToOpen = [
        'closeButton_',
        'information_0_',
        'information_1_',
        'button_',
        'card_0_',
        'card_1_',
        'card_2_',
        'description_',
      ];

      needToOpen.forEach(key => {
        let open = this.$refs[key + index];
        if (open && open.length !== 0) {
          // there is only one element which should be opened
          open = open[0];
          open.classList.remove('landing-hide');
        }
      });

      this.cardOpened = true;
    },
  },
};
</script>
